/* Froggy theme — minimal JS */
(function () {
  window.frgToggleMenu = function (open) {
    var p = document.getElementById('frg-mobile');
    if (p) p.classList.toggle('open', open);
  };

  document.addEventListener('DOMContentLoaded', function () {
    // Product: swap main image when a thumbnail is clicked
    document.querySelectorAll('[data-frg-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = document.querySelector('[data-frg-main-img]');
        if (main) main.src = t.getAttribute('data-full') || t.src;
      });
    });

    // Product: sync option dropdowns -> hidden variant <select>
    var form = document.querySelector('[data-frg-product-form]');
    if (!form) return;
    var options = form.querySelectorAll('[data-frg-option]');
    var idSelect = form.querySelector('[name="id"]');
    var mapEl = form.querySelector('[data-frg-variant-map]');
    if (!options.length || !idSelect || !mapEl) return;

    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

    var addBtn = form.querySelector('[data-frg-add]');
    var priceEl = document.querySelector('[data-frg-price]');

    function sync() {
      var chosen = [];
      options.forEach(function (s) { chosen.push(s.value); });
      var variant = map[chosen.join(' / ')];
      if (!variant) return;
      idSelect.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (priceEl && variant.price) priceEl.textContent = variant.price;
    }

    options.forEach(function (s) { s.addEventListener('change', sync); });
    sync();
  });
})();
